import SectionHeading from '@/pages/home/components/SectionHeading';
import { authenticityChecks } from '@/mocks/home';

export default function AuthenticitySection() {
  return (
    <section id="authenticity" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="真伪辨别"
          title="神马影院是不是假的？先看这六个信号"
          desc="“神马影院”这个名字下存在大量同名但彼此独立的站点与 App。与其纠结“哪个是真的”，不如学会识别可疑信号，自己判断眼前这个能不能信。"
        />

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {authenticityChecks.map((c, i) => (
                <div key={c} className="flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200">
                  <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800 font-heading font-bold text-sm">
                    {i + 1}
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed">{c}</p>
                </div>
              ))}
            </div>
          </div>

          <aside className="rounded-lg bg-accent-50 border border-accent-200 p-6">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-700 mb-4">
              <i className="ri-search-eye-line"></i>
              判断原则
            </span>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              真正的正规平台，通常有稳定的品牌域名、明确的主体信息和一致的界面风格。而一个“名字一样、域名不同、界面各异、联系方式成谜”的站点，
              更可能是借用名称的克隆或仿冒站。
            </p>
            <div className="pt-4 border-t border-accent-200">
              <p className="text-xs text-foreground-500 leading-relaxed">
                当对方越是催促你“马上下载”“限时付款”“加官方群领激活码”，就越应该停下来想一想：它为什么这么着急？
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}